var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgGameGrid = function SvgGameGrid(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 5a2 2 0 012-2h14a2 2 0 012 2v1.5a2 2 0 01-2 2H5a2 2 0 01-2-2V5zm0 7a2 2 0 012-2h14a2 2 0 012 2v1.5a2 2 0 01-2 2H5a2 2 0 01-2-2V12zm2 5a2 2 0 00-2 2v1.5a2 2 0 002 2h14a2 2 0 002-2V19a2 2 0 00-2-2H5z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgGameGrid);
export default ForwardRef;